<div id="contents" role="main" data-ng-view="" class="ng-scope" style="min-height: 395px;">
	<div class="progress">
		<ul>
			<li class="done"><i class="sp ico_progress1"></i><span>SELECT PRODUCT</span></li>
			<li class="done"><i class="sp ico_progress2"></i><span>INPUT PERSONAL INFORMATION</span></li>
			<li class="active"><i class="sp ico_progress3"></i><span>MAKE PAYMENT</span></li>
			<li><i class="sp ico_progress4"></i><span>COMPLETE PAYMENT</span></li>
		</ul>
	</div>
	<div class="container">
		<div>
			<!-- <ui-payment> -->
			<section class="flex_bx payment_section">
				<div style="display:none" class="flex_bx_inner sec_accordian sec_reg close inactive ng-hide"
					data-ng-class="{'open': vm.data.oldCardUseYn == 'Y', 'close': vm.data.oldCardUseYn == 'N', 'inactive': vm.data.oldCardUseYn == 'N'}"
					data-ng-show="vm.cardExist">
					<div data-ng-show="vm.OLD_CARD_VIEW_TYPE == 'Payment'">
						<div class="heading">
							<span class="input_radio_basic">
								<input type="radio" data-ng-model="vm.data.oldCardUseYn" value="Y" id="oldCard"
									class="ng-pristine ng-untouched ng-valid ng-not-empty" name="223">
								<label for="oldCard">
									<h2 class="h3">Payment by registered card</h2>
								</label>
							</span>
						</div>
						<!-- ngIf: vm.cardExist -->
					</div>
					<div data-ng-show="vm.OLD_CARD_VIEW_TYPE == 'Update'" class="ng-hide">
						<div class="heading">
							<span class="input_radio_basic">
								<!--					<input type="radio" data-ng-model="vm.data.oldCardUseYn" value="Y" id="updateOldCard">-->
								<label for="updateOldCard">
									<h2 class="h3">Registered card</h2>
								</label>
							</span>
						</div>
						<div class="ac_container" data-ng-class="{'more': vm.cardExist &amp;&amp; vm.cardList.length > 2}">
							<!-- ngRepeat: x in vm.cardList -->
						</div>
						<div class="btn_area only ng-hide" data-ng-show="vm.cardExist &amp;&amp; vm.cardList.length > 2">
							<a href="#" class="btn btn_more" data-ng-click="on.more()">more<i class="sp ico_more"></i></a>
						</div>
					</div>
				</div>
				<!-- //payment by registered card -->
				<!-- ngIf: vm.OLD_CARD_VIEW_TYPE == 'Payment' -->
				<div style="display:none" class="sec_hr ng-hide" data-ng-show="vm.cardExist"
					data-ng-if="vm.OLD_CARD_VIEW_TYPE == 'Payment'"><span>or</span></div>
				<!-- end ngIf: vm.OLD_CARD_VIEW_TYPE == 'Payment' -->
				<!-- Payment by your new card  -->
				<div class="flex_bx_inner sec_accordian sec_new open" data-ng-class="{'open': vm.data.oldCardUseYn == 'N'}">
					<div class="heading">
						<div class="sub-title"><h3>Make Payment</h3>
							<p>All transaction are secure and encrypted.</p>	<span class="obj_right">
								<span class="sp ico_sm_card1">VISA</span>
								<span class="sp ico_sm_card2">Master Card</span>
								<!-- ngIf: vm.PATH_COUNTRY === 'us' --><span class="sp ico_sm_card3"
									data-ng-if="vm.PATH_COUNTRY === 'us'">DISCOVER</span><!-- end ngIf: vm.PATH_COUNTRY === 'us' -->
								<!--<span class="sp ico_sm_card4">JCB</span>-->
								<!-- ngIf: vm.PATH_COUNTRY === 'au' || vm.PATH_COUNTRY === 'us' --><span class="sp ico_sm_card5"
									data-ng-if="vm.PATH_COUNTRY === 'au' || vm.PATH_COUNTRY === 'us'">AMEX</span>
								<!-- end ngIf: vm.PATH_COUNTRY === 'au' || vm.PATH_COUNTRY === 'us' -->
							</span></div>

					</div>
					<!-- ac_container -->

					<!-- <div class="form_wrap ac_container"> -->
					<form [formGroup]="form" class="form_wrap ac_container" #myForm="ngForm">
						<p class="info_txt">Credit / Debit Card</p>
						<div class="form_group_col2_wrap form_name">
						<div class="form_group col2">
							<div class="tit"><label for="inp01">Name on card <i class="ico_compulsory">*</i></label></div>
							<div class="txt">
								<span class="inp_wrap">
									<input (keypress)="keyPressAlphaNumericSpaceOnly($event)" [value]="form.value.name" formControlName="name" type="text" id="inp01" autocomplete="cc-name"
										placeholder="Name on card" remove-special-char="&" limit-char="" limit="30">
									<span class="focus-border"><i></i></span>
								</span>
								<span *ngIf="form.controls.name.dirty && form.controls.name.hasError('required')" class="warning">
									Enter cardholder's name.
								</span>
							</div>
						</div>
						<div class="form_group col2 ng-hide" data-ng-show="vm.OLD_CARD_VIEW_TYPE == 'Update'">
							<div class="tit"><label for="labelPostalCode">Billing Zip Code <i class="ico_compulsory">*</i></label>
							</div>
							<div class="txt">
								<span class="inp_wrap">
									<input [value]="form.value.postalCode" formControlName="postalCode" type="text" id="labelPostalCode"
										placeholder="Billing Zip Code" post-code-mask="" numbers-only="09" minlength="5" maxlength="5"
										limit-char="" limit="5">
									<span class="focus-border"><i></i></span>
								</span>
								<span *ngIf="form.controls.postalCode.dirty && form.controls.postalCode.hasError('required')"
									class="warning">Please enter proper zip code.</span>
								<span
									*ngIf="(form.controls.postalCode.dirty || form.controls.postalCode.touched) && form.controls.postalCode.hasError('pattern')"
									class="warning">
									Zip code must be numbers only
								</span>
							</div>
						</div>
					</div>

						<div class="form_group only">
							<div class="tit">
								<label for="inp02">
									Card number <i class="ico_compulsory">*</i>
								</label>
							</div>
							<div class="txt">
								<span class="inp_wrap">
									<input (keypress)="keyPressNumbersOnly($event)" [value]="form.value.number" (input)="formatCreditCard($event.target.value)"
										formControlName="number" type="tel" id="inp02" maxlength="19">
									<span class="focus-border"><i></i></span>
								</span>
								<span *ngIf="form.controls.number.dirty && form.controls.number.hasError('required')" class="warning">
									Invalid card number. Please check and try again.
								</span>
								<span
									*ngIf="(form.controls.number.dirty || form.controls.number.touched) && form.controls.number.hasError('pattern')"
									class="warning">
									Card number must be numbers only
								</span>
								<span class="warning off" id="cardNumber">
									Invalid card number. Please check and try again.
								</span>
								<span class="warning off" id="cardAvailable">
									Only Visa, MasterCard, and American Express are accepted.
								</span>
							</div>
						</div>
						<div class="row" style="padding-bottom:20px;">
							<div class="col-md-4 col-xs-12" data-ng-class="{'inp_cvv': vm.OLD_CARD_VIEW_TYPE == 'Update'}">
								<div class="form_group only">
							<div class="tit"><label for="inp03">CVV <i class="ico_compulsory">*</i></label></div>
							<div class="txt">
								<span class="inp_wrap">
									<input (keypress)="keyPressNumbersOnly($event)" [value]="form.value.securityCode" formControlName="securityCode" type="password" id="inp03"
										autocomplete="cc-csc" numbers-only="" limit-char="" minlength="3" maxlength="4" placeholder="CVV" #cvv>
									<!-- <input [value]="form.value.securityCode" formControlName="securityCode" type="password" id="inp03"
										autocomplete="cc-csc" numbers-only="" limit-char="" minlength="3" maxlength="4" placeholder="CVV"> -->
									<span class="focus-border"><i></i></span>
								</span>
								<span
									*ngIf="form.controls.securityCode.dirty && form.controls.securityCode.hasError('required') && form.controls.securityCode.hasError('pattern')"
									class="warning">
									CVC Number is not correct.
								</span>
								<span
									*ngIf="(form.controls.securityCode.dirty || form.controls.securityCode.touched) && form.controls.securityCode.hasError('pattern')"
									class="warning">
									CVC Number is not correct.
								</span>
								<!-- <div class="tooltip_wrap">
									<a href="#" class="btn_tooltip"><i class="sp ico_tooltip">What's CVV?</i></a>
									<div class="tip_box">
										<div class="inner">
											<p>The CVV Number ("Card Verification Value") on your credit card or debit
												card is a 3 digit number on VISA, MasterCard and Discover branded credit and debit cards. On
												your American Express branded credit or debit card it is a 4 digit numeric code.</p>cvv
											<div class="tip_img"><i class="sp img_card"></i></div>
											<span class="element_solid"><i class="triangle"></i></span>
										</div>
									</div>1
								</div> -->
								<span class="warning off" id="cardCvv">CVC Number is not correct.</span>
							</div>
						</div>
						</div>
						<div class="col-md-4 col-xs-12">
							<div class="form_group only">
							<div class="tit"><label>Expiration Date <i class="ico_compulsory">*</i></label></div>
							<div class="txt">
									<span class="inp_select">
										<select formControlName="expirationMonth">
											<!-- <option [ngValue]="null">MM</option> -->
											<option value="" disabled selected>MM</option>
											<option *ngFor="let item of months" [ngValue]="item.value">{{ item.title }}</option>
										</select>
										<span class="focus-border"><i></i></span>
									</span>
									<!--
									<input type="tel" autocomplete="cc-exp-month" data-ng-model="vm.data.cardDateMonth" numbers-only remove-special-char limit-char limit="2" minlength="2"><span class="focus-border"><i></i></span>
									<span class="warning col2ahead off" id="cardDateYear">This card has expired. Please try again.</span>
									-->
							</div>
						</div>
						</div>
						<div class="col-md-4 col-xs-12">
							<div class="form_group only">
							<div class="tit"><label>Expiration Date <i class="ico_compulsory">*</i></label></div>
							<div class="txt">
									<span class="inp_select">
										<select formControlName="expirationYear">
											<option value="" disabled selected>YYYY</option>
											<option *ngFor="let item of years" [ngValue]="item.value">{{ item.title }}</option>
										</select>
										<span class="focus-border"><i></i></span>
									</span>
									<!--						<input type="tel" autocomplete="cc-exp-year" data-ng-model="vm.data.cardDateYear" numbers-only remove-special-char limit-char limit="4" minlength="2"><span class="focus-border"><i></i></span>-->
								</div>
							</div>
						</div>
					</div>
					<div class="btn_area">
						<a class="btn btn_type2" (click)="onPrevious()"><img src="./assets/images/button-arrow-pre.png">Previous</a>
						<a class="btn btn_type1" [ngClass]="{'disable': !myForm.form.valid}" (click)="onNext()">Review Order<img src="./assets/images/button-arrow.png"></a>
					</div>
					</form>
					<!-- //ac_container -->
				</div>
				<!-- //Payment by your new card  -->
			</section>
		</div>
		<!-- </ui-payment> -->

		<!-- Product Details -->
		<section class="flex_bx pr_sum order-summary-box">
			<div class="summary-title"><h3 class="h3">Order Summary</h3></div>
			<ul class="pr_info">
				<li class="pr_info_detail"><span class="tit">MODEL CODE</span> <span>{{ this.shared.modelCode }}</span></li>
				<li class="pr_info_detail"><span class="tit">SERIAL NUMBER</span> <span>{{ this.shared.serialNumber }}</span></li>
			</ul>

			<div class="summarty-item">
				<div class="summarty-item-left">
					<ul>
						<li><span class="care-logotype">Samsung Care+</span></li>
						<li><span class="item-title">{{product.SKUDESC}}</span></li>
						<li><span class="coverage-period">Additional {{product.TERM}}-months coverage</span></li>
					</ul>
				</div>
				<div class="summarty-item-right">
					<div>
					<span class="item-price">${{product.TECHNICIANID ? product.PRICE - product.DISCOUNTAMOUNT : product.PRICE}}</span>
					<span class="payment-frequency">{{product.PAYMENTFREQUENCY}}</span>
				</div>
					</div>
				<!--p class="notifying text-center">plus applicable sales tax</p-->
			</div>
			<div class="summarty-item">
				<div class="summarty-item-left">
					<ul>
						<li><span>Total before Tax</span></li>
						<li><span>Estimated Sales Tax</span></li>
					</ul>
				</div>
				<div class="summarty-item-right">
					<span class="item-price">${{product.TECHNICIANID ? product.PRICE - product.DISCOUNTAMOUNT : product.PRICE}}</span>
					<span>Calculated in checkout</span>
					</div>
				<!--p class="notifying text-center">plus applicable sales tax</p-->
			</div>
			<div class="total-wrapper">
				<div class="total-item">Total</div>
				<div class="total-price">${{product.TECHNICIANID ? product.PRICE - product.DISCOUNTAMOUNT : product.PRICE}}</div>
			</div>
			<p class="terms">
				By placing your order, you agree to Samsung's
				<a href="https://www.asurion.com/pdf/samsung-after-market-for-consumer-electronics/" class="link" target="_blank">Terms
					and Conditions</a> and <a href="https://www.samsung.com/us/account/privacy-policy/" class="link"
					target="_blank">Privacy Policy</a>
			</p>
		</section>

		<!-- //Product Details -->


		<div style="display:none;">
			<form id="actionFormIdentify" method="post" action="" target="actionIdentify" class="ng-pristine ng-valid">
				<input id="threeDSMethodData" name="threeDSMethodData" type="hidden" value="" autocomplete="off">
				<button type="submit">Àü¼Û</button>
			</form>
			<iframe id="actionIdentify" name="actionIdentify" width="100%" height="640px"></iframe>
		</div>
	</div>
</div>
